var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12", md: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("settings")))]),
                      _c(
                        "w-card-content",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("auto-save-product-composition"),
                            },
                            on: { input: _vm.save },
                            model: {
                              value: _vm.AutoUpdateProductComposition,
                              callback: function ($$v) {
                                _vm.AutoUpdateProductComposition = $$v
                              },
                              expression: "AutoUpdateProductComposition",
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mt",
                            attrs: {
                              label: _vm.$ct("get-purchase-price-from-product"),
                            },
                            on: { input: _vm.save },
                            model: {
                              value: _vm.GetPurchasePriceFromProductWhenZero,
                              callback: function ($$v) {
                                _vm.GetPurchasePriceFromProductWhenZero = $$v
                              },
                              expression: "GetPurchasePriceFromProductWhenZero",
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mt",
                            attrs: {
                              label: _vm.$ct(
                                "show-supplier-filter-on-price-list-open"
                              ),
                            },
                            on: { input: _vm.save },
                            model: {
                              value: _vm.ShowSupplierFilterOnPriceListOpen,
                              callback: function ($$v) {
                                _vm.ShowSupplierFilterOnPriceListOpen = $$v
                              },
                              expression: "ShowSupplierFilterOnPriceListOpen",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }